// src/pages/DeleteAccountInfo.jsx

import React from 'react';

export default function DeleteAccountInfo() {
  return (
    <div className="max-w-xl mx-auto p-4 text-left">
      <h1 className="text-2xl font-bold mb-4">Delete Your SatStacker Account</h1>
      <p className="mb-4">
        You can delete your SatStacker account at any time from the app's Settings screen.
        This will permanently remove all associated data, including:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Your user profile and email</li>
        <li>Your DCA plans and trade history</li>
        <li>Your withdrawal records</li>
      </ul>
      <p className="mb-4">
        To delete your account:
        <ol className="list-decimal list-inside ml-4 mt-2">
          <li>Open the SatStacker app</li>
          <li>Go to the <strong>Settings</strong> page</li>
          <li>Tap the <strong>Delete Account</strong> button</li>
          <li>Confirm when prompted</li>
        </ol>
      </p>
      <p>
        If you encounter any issues, please contact us at <a href="mailto:support@satstacker.app" className="text-blue-600">support@satstacker.app</a>.
      </p>
    </div>
  );
}
